export default "__VITE_ASSET__Dj10adQT__"